<template>
    <div>
        <v-text-field v-model="dateRangeText" :label="label" prepend-inner-icon="event" readonly @click="openEdit" />
        <v-dialog ref="dialogDate" v-model="showDatePicker" @keydown.esc="cancel" @click:outside="cancel" persistent width="290px">
            <v-date-picker v-model="dates" range>
                <v-btn text color="grey" @click="changeHour" v-if="time">{{ $t("Hora") }}</v-btn>
                <v-spacer />
                <v-btn text color="success" @click="saveDate">OK</v-btn>
            </v-date-picker>
        </v-dialog>
        <v-dialog ref="dialogTime" v-model="showTimePicker" @keydown.esc="cancel" @click:outside="cancel" persistent>
            <v-card color="white" class="pa-2">
                <v-card-text class="text-center pt-8">
                    <v-row>
                        <v-col>
                            <h2>Inicio: {{ $moment(dates[0]).format("DD/MM/YYYY") }}</h2>
                            <v-time-picker v-model="times[0]" full-width format="24hr" />
                        </v-col>
                        <v-col>
                            <h2>Fim: {{ $moment(dates[1]).format("DD/MM/YYYY") }}</h2>
                            <v-time-picker v-model="times[1]" full-width format="24hr" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-spacer />
                        <v-btn text color="success" @click="saveTime">OK</v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import dateTime from "@/helpers/DateTime";

export default {
    name: "DateInterval",

    props: {
        today: {
            type: Boolean,
            default: false,
        },
        time: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: "Intervalo",
        },
        limit: {
            type: Number,
            default: 30,
        },
    },

    data() {
        return {
            dateTime,
            showDatePicker: false,
            showTimePicker: false,
            dates: [],
            datesBackup: [],
            times: ["00:00", "23:59"],
            timesBackup: ["00:00", "23:59"],
        };
    },

    methods: {
        openEdit() {
            this.times = ["00:00", "23:59"];
            this.showDatePicker = true;
        },
        saveDate() {
            this.showDatePicker = false;
            this.emitChange();
        },
        changeHour() {
            this.validateDate();
            this.showDatePicker = false;
            this.showTimePicker = true;
        },
        cancel() {
            this.showDatePicker = false;
            this.showTimePicker = false;
            this.dates = this.datesBackup.slice();
            this.times = this.timesBackup.slice();
        },
        saveTime() {
            this.showTimePicker = false;
            this.emitChange();
        },
        validateDate() {
            if (this.dates.length > 0) {
                if (this.dates.length == 1) {
                    this.dates.push(this.dates[0]);
                }
                if (this.$moment(this.dates[0]).isAfter(this.$moment(this.dates[1]))) {
                    this.dates.reverse();
                }
            }
        },
        emitChange() {
            if (this.dates.length > 0) {
                this.validateDate();
                this.$emit("onChange", [`${this.dates[0]}T${this.times[0]}`, `${this.dates[1]}T${this.times[1]}`]);

                this.datesBackup = this.dates.slice();
                this.timesBackup = this.times.slice();
            }
        }
    },

    created() {
        if (this.today) {
            this.dates[0] = this.$moment().subtract({ hours: 3 }).toISOString().substr(0, 10);
            this.dates[1] = this.$moment().subtract({ hours: 3 }).toISOString().substr(0, 10);
        } else {
            this.dates[0] = this.$moment().subtract({ months: 1, hours: 3 }).toISOString().substr(0, 10);
            this.dates[1] = this.$moment().subtract({ hours: 3, days: 1 }).toISOString().substr(0, 10);
        }
        this.emitChange();
    },

    computed: {
        dateRangeText: {
            get: function () {
                if(this.dates.length == 2) {
                    return `${this.$moment(this.dates[0]).format("DD/MM/YYYY")} ${this.times[0]} à ${this.$moment(this.dates[1]).format("DD/MM/YYYY")} ${this.times[1]}`;
                }
                return `${this.$moment(this.dates[0]).format("DD/MM/YYYY")} ${this.times[0]}`;
            },
            set: function () {
                if ((new Date(this.dates[1]).getTime() - new Date(this.dates[0]).getTime()) / (1000 * 3600 * 24) > this.limit) {
                    this.$eventHub.$emit("msgError", this.$t(`Selecione um periodo de tempo menor que ${this.limit} dias.`));
                }
            },
        },
    },
};
</script>